/**
 * The bloomneo mark — six petals, one path rotated six times.
 *
 * ── Why it keeps its own colour ───────────────────────────────────────────
 * The petals stay gold while the rest of the interface is a deep pine green.
 * That is deliberate, not an oversight: the accent marks what you can *click*,
 * and the mark marks *whose product this is*. Tinting the logo to match the
 * primary would fold identity into interaction and lose both.
 *
 * `size` is in pixels and the geometry scales with it — the viewBox is fixed,
 * so this stays crisp at 20px in a sidebar and 64px on a splash.
 */
const PETAL = 'M0,0C9,-12 11,-30 0,-40C-11,-30 -9,-12 0,0';
const ANGLES = [0, 60, 120, 180, 240, 300];

export function Logo({ size = 28, className = '' }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={className}
      role="img"
      aria-label="bloomneo"
    >
      <g transform="translate(50,50)">
        {ANGLES.map((deg) => (
          <path key={deg} d={PETAL} transform={`rotate(${deg})`} fill="var(--color-brand-mark)" />
        ))}
      </g>
    </svg>
  );
}
